import { useEffect } from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { HomePage } from '@/pages/HomePage';
import { ChartPage } from '@/pages/ChartPage';
import { ChatPage } from '@/pages/ChatPage';
import { DivinationPage } from '@/pages/DivinationPage';
import { MembershipPage } from '@/pages/MembershipPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { CompatibilityPage } from '@/pages/CompatibilityPage';
import { FortunePage } from '@/pages/FortunePage';
import { CouponsPage } from '@/pages/CouponsPage';
import { InvitePage } from '@/pages/InvitePage';
import { PushSettingsPage } from '@/pages/PushSettingsPage';
import { UnsubscribePage } from '@/pages/UnsubscribePage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { CodeFlowPage } from '@/pages/auth/CodeFlowPage';
import { useAuthStore } from '@/lib/auth.store';
import { ToastProvider } from '@/components/ui/Toast';

export function App() {
  const hydrate = useAuthStore((s) => s.hydrate);
  const location = useLocation();
  const immersivePages = ['/chart', '/compatibility', '/fortune', '/divination'];
  const isImmersivePage =
    immersivePages.includes(location.pathname) ||
    location.pathname === '/chat' ||
    location.pathname.startsWith('/chat/');

  useEffect(() => {
    void hydrate();
  }, [hydrate]);

  return (
    <ToastProvider>
      <div
        className={
          isImmersivePage
            ? 'flex h-screen min-h-0 flex-col overflow-hidden bg-bg text-fg'
            : 'min-h-screen flex flex-col bg-bg text-fg'
        }
      >
        <Header />
        <div
          className={isImmersivePage ? 'min-h-0 flex-1 overflow-hidden' : 'flex-1 flex flex-col'}
        >
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/chart" element={<ChartPage />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/chat/:id" element={<ChatPage />} />
            <Route path="/divination" element={<DivinationPage />} />
            <Route path="/wallet" element={<Navigate to="/membership" replace />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/profile" element={<ProfilePage />} />

            <Route path="/compatibility" element={<CompatibilityPage />} />
            <Route path="/fortune" element={<FortunePage />} />
            <Route path="/coupons" element={<CouponsPage />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/settings/push" element={<PushSettingsPage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />

            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/auth/register" element={<CodeFlowPage mode="register" />} />
            <Route path="/auth/set-password" element={<CodeFlowPage mode="set-password" />} />
            <Route path="/auth/reset-password" element={<CodeFlowPage mode="reset-password" />} />

            <Route
              path="*"
              element={
                <main className="flex-1 flex items-center justify-center">
                  <div className="text-center">
                    <p className="font-serif text-6xl text-accent mb-4">404</p>
                    <p className="text-fg-2">此处空空如也</p>
                  </div>
                </main>
              }
            />
          </Routes>
        </div>
        {!isImmersivePage && <Footer />}
      </div>
    </ToastProvider>
  );
}
